import type { LeaderboardSort, TopicSummary } from '../types';

export function rankTopics(
  topics: readonly TopicSummary[],
  sort: LeaderboardSort,
): TopicSummary[] {
  return [...topics].sort((a, b) => {
    if (sort === 'flowers') {
      return (
        b.flowerCount - a.flowerCount ||
        b.likeCount - a.likeCount ||
        a.displayOrder - b.displayOrder
      );
    }

    return (
      b.likeCount - a.likeCount ||
      b.flowerCount - a.flowerCount ||
      a.displayOrder - b.displayOrder
    );
  });
}
